import React, { useEffect, useRef, useContext } from "react";
import PopCharFurther from "./popCharFurther";
import MyContext from "../../../../context/MyContext";
import TickerContext from "../../../../context/ticker";
import AuthContext from "../../../../context/userAuth.context";

export const AssetsPopup = (props) => {
  const charPopRef = useRef();

  const { CharacterData } = useContext(MyContext);
  const {Access} = useContext(AuthContext)
  const {premiumActionsArray} = useContext(TickerContext)
  
  useEffect(() => {
    charPopRef.current.scrollTo(0, 0);
  }, [props]);

  useEffect(() => {
    charPopRef.current.focus();
    // console.log(CharacterData.poseList);
  }, []);

  const out = (params) => {
    props.setchrPop(false);
  };

  return (
    <>
      <div
        className="charpoparrow"
        style={{
          top: parseInt(props.positions.top),
          left: props.positions.left,
          zIndex: 999,
        }}
      ></div>
      <div
        className="charpop "
        ref={charPopRef}
        tabIndex="1"
        onMouseLeave={out}
        onBlur={out}
        style={{
          // top: parseInt(props.positions.top) - 185,
          top: document
            .getElementsByClassName("templatesWrapper2")[0]
            .getBoundingClientRect().y,
          left: props.positions.left + 10,
        }}
      >
        <div
          className="style-1"
          style={{ height: "475px", overflowY: "scroll" }}
        >
          <div
            className="Character_folder_items"
            style={{ borderBottom: "none", marginBottom: "0", padding: "0" }}
          >
            <div className="Cfi" style={{ width: "100%", height: "auto" }}>
              <div className="Char_assetsList" style={{ padding: "0px" }}>
                {CharacterData.poseList.map((obj, index) => {
                  return (
                    <div key={index} style={{ marginBottom: "11px" }}>
                      <div
                        className="Asset_items"
                        style={{
                          marginBottom: "0px",
                          background: "#dfdfdf",
                        }}
                      >{Access == "FE" && premiumActionsArray.includes(index) ? (<img
                        style={{
                         position: "absolute",
                         top: "5px",
                         right: "5px",
                         width: "20px",
                         height: "20px",
                         zIndex: "1"
                       }}
                         src="../AppIcons/IconsAll/PremiumIcon.svg"
                         alt=""
                       />):null} 
                        <PopCharFurther
                          fileName={obj.poseFile}
                          data={CharacterData}
                          obj={obj}
                          isPremiumCharacter={premiumActionsArray.includes(index)}
                        />
                      </div>
                      <div className="charpopName">{obj.poseName}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetsPopup;
